import React, { SVGProps } from 'react';

const NewBatch = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={26}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="NewBatch">
    <rect width={26} height={12} rx={6} fill="#D75750" />
    <path
      d="m9.515 9-.01-6.21h-.971v2.988c0 .639.009 1.467.027 2.169L5.78 2.79H4.385V9h.99V6.03c0-.639-.01-1.44-.036-2.151L8.093 9h1.422Zm5.384-2.511c0-1.35-.746-2.394-2.132-2.394-1.377 0-2.34 1.017-2.34 2.529 0 1.692.963 2.502 2.24 2.502 1.044 0 1.954-.54 2.16-1.674h-.998c-.1.603-.55.954-1.126.954-.647 0-1.17-.378-1.25-1.521h3.429c.018-.171.018-.306.018-.396Zm-2.168-1.674c.693 0 1.08.495 1.152 1.377h-2.421c.107-.918.594-1.377 1.268-1.377Zm9.715-.594h-1.053l-.98 3.906-.955-3.897h-1.206l-.927 3.888-.98-3.897h-1.117L16.75 9h1.143l.954-3.861L19.791 9h1.134l1.521-4.779Z"
      fill="#fff"
    />
  </svg>
);

export default NewBatch;
